import { EMPTY_ARRAY } from "config/constants";
import { useDispatch, useSelector } from "react-redux";
import { Intensity } from "store/types";
import {
  getIntensities,
  updateCustomIntensities,
} from "../actions/intensities";
import { RootState } from "../reducers";

export const selectIntensitiesByTeam =
  (teamId: string) =>
  (state: RootState): Intensity[] =>
    state.intensities.teamsById[teamId] ?? EMPTY_ARRAY;

export const useIntensitiesDispatch = () => {
  const dispatch = useDispatch();
  return {
    getIntensities: (teamId: string, forcedScope?: string) =>
      dispatch(getIntensities(teamId, forcedScope)),
    updateCustomIntensities: (intenisties: Intensity[], teamId: string) =>
      dispatch(updateCustomIntensities(intenisties, teamId)),
  };
};
